export enum Languages {
  ES = 'es-ES',
  EN = 'en-US',
}
export const languageList: string[] = [Languages.EN, Languages.ES] as const
